import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { IExamStatsByAnswerRate } from "../../../models/statistics.model";
import { upperCase } from "lodash";
import { ApexOptions } from 'apexcharts';
import Chart from 'react-apexcharts';

interface IProps {
  data: IExamStatsByAnswerRate[]|undefined;
}

const ExamAnswerRateGraph: FC<IProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  let series: ApexOptions['series'] = [];
  let options: ApexOptions = {};

  if(data) {
    series = [
      {
        name: 'Average',
        data: data.map((value) => {
          return Math.floor(Number(value.correctAnswerRate) * 10) / 10;
      
        }
      
      ),
        group: 'Average',
      },
    ];

    options = {
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: { show: false },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            total: {
              enabled: false,
            },
          },
        },
      },
      xaxis: {
        type: 'category',
        categories: data.map((value, idx) => 'Q' + (idx+1)),
      },
      yaxis: {
        max: 100
      },
      legend: {
        position: 'bottom',
        show: true,
        showForSingleSeries: true
      },
      dataLabels: { enabled: true },
      colors: ["#697480"]
    };
  }

  return data?.length
    ? (
      <div style={{ width: '100%', height: '70vh' }}>
        <Chart series={series} options={options} type="bar" height="100%" />
      </div>
      )
    : null
}

export default ExamAnswerRateGraph;
